import { Modal, Button } from "react-bootstrap";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function ConfirmModal(props) {
    const { t } = useTranslation();

    return (
        <div id="confirm-modal">
            <Modal
                {...props}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="confirm-modal"
            >
                <Modal.Body>
                    <h4>{props.title}</h4>
                    <p>{props.description}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="confirm-btn" onClick={props.onConfirm}>
                        {props.btnTitle}
                    </Button>
                    <Button className="cancel-btn" onClick={props.onHide}>
                        {t("Organizational.Profile.Cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
